export const MAX_MESSAGES = 50

export const EMOJI_BASE_URL = 'https://twemoji.maxcdn.com/2/72x72'

export const PING_EVERYONE = 'everyone'
export const PING_MODS = 'mods'

export const KEY_SEND = 'Enter'
export const KEY_AC_SELECT = 'Tab'
export const KEY_AC_UP = 'ArrowUp'
export const KEY_AC_DOWN = 'ArrowDown'

export const AC_TYPE_MENTION = 'mention'
export const AC_TYPE_EMOTE = 'emote'
export const AC_MAX_SUGGESTIONS = 10
